var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 80,
    viewBox: "0 0 82 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.2705 79.4037L41.2973 65.9966L41.3249 53.302",
    fill: "#A9CF3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3769 79.4137L36.1631 79.3938L36.2174 53.2909L46.4311 53.313L46.3769 79.4137Z",
    fill: "#A9CF3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0004 38.9767C18.5031 38.9767 0.221334 56.6298 0.401714 78.2619C0.40435 78.2646 0.40607 78.2662 0.408821 78.269H4.3931H10.605H21.7197V68.0553H12.4494C16.722 57.0573 27.9081 49.1904 41.0003 49.1904C54.0927 49.1904 65.2788 57.0573 69.5514 68.0553H60.305V78.269H71.3958H79.1632H81.5917C81.5946 78.2662 81.5962 78.2646 81.5991 78.2619C81.7798 56.6298 63.4978 38.9767 41.0004 38.9767Z",
    fill: "#587E85"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3326 49.1914C27.4687 49.1914 16.1895 38.3494 16.1895 25.0224C16.1893 11.6956 27.4687 0.853516 41.3326 0.853516C55.1964 0.853516 66.4756 11.6956 66.4756 25.0224C66.4756 38.3494 55.1963 49.1914 41.3326 49.1914ZM41.3326 11.0672C33.1004 11.0672 26.4032 17.3272 26.4032 25.0224C26.4032 32.7177 33.1004 38.9777 41.3326 38.9777C49.5647 38.9777 56.2618 32.7177 56.2618 25.0224C56.2618 17.3272 49.5647 11.0672 41.3326 11.0672Z",
    fill: "#A9CF3D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3566 66.0488L40.9494 66.0221L28.2549 65.9944",
    fill: "#A9CF3D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.366 60.9421L54.346 71.1559L28.2432 71.1017L28.2653 60.8879L54.366 60.9421Z",
    fill: "#A9CF3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/account-icon.374b3e6a13ca8bd0805201ef8533216f.svg";
export { ForwardRef as ReactComponent };